import superTable from '../components/components-items/super-table.vue';



// 为组件添加 install 方法，用于按需引入
superTable.install = function (Vue) {
    Vue.component(superTable.name, superTable)
}




export default superTable